import {combineReducers} from 'redux'
function getDataTemplate() {
  const data = {
    name: "",
    designation: "",
    address: "",
    email: "",
    contact: "",
    education: [],
    skills: [],
    langKnown: [],
    workExp: [],
    projects: [],
    interests: [],
    addInfo:[],
    intro: ""
  };
  return data;
}
function dataReducer(state=getDataTemplate(),{type,payload}){
	switch(type){
		case 'SET_PERSONAL_INFO':  return {
        								...state,
        								name: payload.name,
        								designation: payload.designation,
        								address: payload.address,
        								email: payload.email,
        								contact: payload.contact
      								}
		case 'SET_EDUCATION_DETAILS':return {
								...state,
								education:[...payload]
							}
		case 'SET_INTERESTS':return {
								...state,
								interests:[...payload]
							}
		case 'SET_LANG_KNOWN':return {
								...state,
								langKnown:[...payload]
							}
		case 'SET_PROJECTS':return {
								...state,
								projects:[...payload]
							}
		case 'SET_SKILLS':return {
								...state,
								skills:[...payload]
							}
		case 'SET_WORK_EXP':return {
								...state,
								workExp:[...payload]
							}
		case 'SET_INTRO':return {
								...state,
								intro:payload
							}
		case 'SET_ADDITIONAL_INFO':return {
								...state,
								addInfo:[...payload]
							}
		default: return state
	}
}

export const reducers=combineReducers({
	resumeData:dataReducer
})